module.exports = __webpack_public_path__ + "img/paymentSuccessful.6f34f30d.svg";